module.exports = __webpack_public_path__ + "img/happy-coin.1576766f.png";